import React from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Grid2, Paper, Typography, Button, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter, Link, useLocation } from 'react-router-dom';
import DoneIcon from '@mui/icons-material/Done';
import { WithContexts } from '../../../contexts/withContexts';
import { COLORS } from '../../../utils/Application_Constants';

const STORAGE_KEY = 'submittedDialogState';

const styles = () => ({
    root: {
        background: COLORS.LT_MIDNIGHTBG1,
        minHeight: '600px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    paper: {
        paddingLeft: '32px',
        paddingRight: '32px',
    },
    GridRoot: {
        minHeight: '300px',
        minWidth: '400px',
    },
    doneIcon: {
        color: COLORS.LT_EMERALD,
        background: COLORS.LT_EMERALD10,
        borderRadius: '50%',
        padding: '16px',
    },
    buttonContainer: {
        display: 'flex',
        gap: '16px',
        paddingTop: '16px',
    },
    journeyButton: {
        color: COLORS.LT_JOURNEY,
        background: COLORS.LT_JOURNEY10,
    },
});

function SubmittedDialog({ classes }) {
    const location = useLocation();
    const getLocationState = () => {
        if (location.state) {
            try {
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(location.state));
            } catch (error) {
                console.error('Error saving state:', error);
            }
            return location.state;
        }
        try {
            const saved = sessionStorage.getItem(STORAGE_KEY);
            return saved ? JSON.parse(saved) : {};
        } catch (error) {
            console.error('Error retrieving saved state:', error);
            return {};
        }
    };
    const state = getLocationState();
    const { listViewUrl, isViewOnly, expenseUrl, type, newExpenseUrl } = state;
    const message = type === 'save' ? 'Expense Saved!' : 'Expense Submitted!';

    return (
        <div className={classes.root}>
            <Container>
                <Grid2 justifyContent="center" alignItems="center" display="flex">
                    <Paper elevation={3} className={classes.paper}>
                        <Grid2
                            container
                            direction="column"
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                            className={classes.GridRoot}
                        >
                            <Grid2>
                                <DoneIcon fontSize="large" className={classes.doneIcon} />
                            </Grid2>
                            <Grid2>
                                <Typography variant="h5">{message}</Typography>
                            </Grid2>
                            <Grid2>
                                <Box className={classes.buttonContainer}>
                                    <Link to={listViewUrl}>
                                        <Button variant="contained" color="primary">
                                            Go to List View
                                        </Button>
                                    </Link>
                                    {type === 'submit' && (
                                        <Link to={newExpenseUrl}>
                                            <Button
                                                variant="contained"
                                                className={classes.journeyButton}
                                            >
                                                Enter New Expense
                                            </Button>
                                        </Link>
                                    )}
                                    <Link to={expenseUrl}>
                                        <Button
                                            variant="contained"
                                            className={classes.journeyButton}
                                        >
                                            {isViewOnly
                                                ? 'View Expense'
                                                : 'Continue Editing Expense'}
                                        </Button>
                                    </Link>
                                </Box>
                            </Grid2>
                        </Grid2>
                    </Paper>
                </Grid2>
            </Container>
        </div>
    );
}

export default WithContexts(withRouter(withTranslation()(withStyles(styles)(SubmittedDialog))));
